export enum DiscountType {
    FirstInvoice = 'first-invoice',
    WireProcessingFee = 'wire-processing-fee',
}
